import Vue from "vue"
import moment from "moment"
import _ from "lodash"
import { EventBus } from '@/services/EventBus'

export default class {
    constructor() {
        this.v = 'v1'
    }

    get(url, options = {}) {
        return Vue.http.get('/api/' + this.v + '/' + url, options).then(r => {
            return r.body.data
        }, r => {

            if (r.status !== 400) {
                EventBus.$emit('error', {
                    message: 'Service is temporarily unavailable',
                    code: r.status,
                });
            }

            return Promise.reject(r)
        })
    }

    getImage(url, options = {}) {
        return Vue.http.get('/api/' + url, options).then(r => {
            let urlCreator = window.URL || window.webkitURL

            return urlCreator.createObjectURL(r.bodyBlob)
        })
    }

    getCams() {
        return this.get('cameras')
    }

    getCam(id) {
        return this.get('cameras/' + id)
    }

    getViews(login) {
        return new Promise((resolve, reject) => {
            let viewsJson = localStorage.getItem('views')
            let views = []

            if (viewsJson) {
                views = JSON.parse(viewsJson)

                if (_.isArray(views) || ! _.isObject(views))
                    localStorage.removeItem('views')

                views = views[login] ? views[login] : []
            }

            resolve(views)
        })
    }

    saveView(view, login) {
        return new Promise((resolve, reject) => {
            let views = JSON.parse(localStorage.getItem('views')) || {}

            if (views && ! views[login])
                views[login] = []

            view = {
                id: view.id,
                name: view.name,
                grid: view.grid,
                cams: view.cams,
            }

            if (isNaN(view.id)) {
                view.id = views[login].reduce((prev, next) => {
                    let id = parseInt(next.id)
                    return id >= prev ? id + 1 : prev;
                }, 1)

                views[login].push(view)
            } else {
                let index = views[login].findIndex(v => view.id === v.id)

                if (index > -1) {
                    views[login][index] = view
                } else {
                    reject()
                }
            }

            localStorage.setItem('views', JSON.stringify(views))
            resolve(view)
        })
    }

    removeView(viewId, login) {
        return new Promise((resolve, reject) => {
            let views = JSON.parse(localStorage.getItem('views') || '{"' + login + '":[]}')
            let index = views[login].findIndex(view => view.id === viewId)

            if (index > -1) {
                views[login].splice(index, 1)
                localStorage.setItem('views', JSON.stringify(views))
                resolve(viewId)
            } else {
                reject()
            }
        })
    }

    getCamImage(id) {
        return this.getImage('v2/cameras/' + id + '/image', { responseType: 'blob' })
    }

    getMapImage(mapId, planId) {
        return this.getImage('v1/maps/' + mapId + '/image/' + planId, { responseType: 'blob' })
    }

    getMaps() {
        return this.get('maps')
    }

    getAlarms(cams, params = {}) {
        return new Promise((resolve, reject) => {
            let requests = []
            let requestDateFormat = 'YYYYMMDDTHHmmss'
            let result = []

            params.start_time = moment(params.start_time).format(requestDateFormat)
            params.stop_time = moment(params.stop_time).format(requestDateFormat)

            cams.forEach(cam => {
                requests.push(this.get('cameras/' + encodeURIComponent(cam.id) + '/protocol', { params: params }))
            })

            Promise.all(requests).then(r => {
                r.forEach((data, i) => {
                    let cam = cams[i]

                    data.events.forEach(event => {
                        result.push({
                            camId: cam.id,
                            name: cam.name,
                            timestamp: moment(event.time, 'DD-MM-YY HH:mm:ss').unix(),
                            ...event,
                        })
                    })
                })

                resolve(result)
            }, e => reject(e))
        })
    }

    getPage(name) {
        return Vue.http.get('/static/pages/' + name + '.html').then(r => {
            return r.body
        })
    }

    getAcsObject(type, id) {
        return new Promise(resolve => {
            this.get(`acsconfig?type=${type}&ids=${id}`).then(r => {
                resolve(r[0])
            })
            .catch(e => {
                console.log(e)
                resolve(null)
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js